import React, { Component } from 'react'
import ComparativoMPVentasReport from './ComparativoMPVentasReport';
import CardFormNoBorder from '../../../../Utils/Cards/CardFormNoBorder';
import './ComparativoMPVentas.css';

export default class ComparativoMPVentasClass extends Component {
    render() {
        return (
            <div className="mb-4 col-12">
                <CardFormNoBorder
                    icon="Side_activos/finca.svg"
                    titulo="COMPARATIVO DE COSTO DE MATERIA PRIMA Y VENTAS"
                    subtitulo="RESUMEN"
                    subtituloForm={"VER"}
                    col="12"
                    noShadow
                >
                </CardFormNoBorder>
                <ComparativoMPVentasReport />
            </div>
        )
    }
}

